export default {
    search: function (params) {
        return window.axios.get(`search`, {params:params});
    },
}